export const REGISTER_USER = "register_user"
export const REGISTER_USER_SUCCESSFUL = "register_user_successfull"
export const REGISTER_USER_FAILED = "register_user_failed"
export const FETCH_USER_REGISTRATION_DATA = "fetch_user_registration_data"
export const FETCH_USER_REGISTRATION_DATA_SUCCESS = "fetch_user_registration_data_success"
export const FETCH_USER_REGISTRATION_DATA_FAILED = "fetch_user_registration_data_failed"

